import manrope400 from '@fontsource/manrope/files/manrope-latin-400-normal.woff2?url';
import manrope600 from '@fontsource/manrope/files/manrope-latin-600-normal.woff2?url';
import manrope800 from '@fontsource/manrope/files/manrope-latin-800-normal.woff2?url';
import { isWorldPath } from '../world/content/paths';

/** Text waits on these. On the map they must be asked for up front, or they queue behind all of its art. */
export function preloadWorldFonts() {
  if (!isWorldPath(window.location.pathname)) return;
  for (const href of [manrope400, manrope600, manrope800]) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.crossOrigin = 'anonymous';
    link.href = href;
    document.head.appendChild(link);
  }
}
